<app-broadcast-layer *ngIf="broadcastUid" [uid]="broadcastUid"></app-broadcast-layer>
